"use client";

import React, { ReactNode } from "react";
import { Drawer } from "antd";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  disableBackdropClose?: boolean;
}

const Modal = ({ isOpen, onClose, title, children, disableBackdropClose }: ModalProps) => {
  return (
    <Drawer
      title={title}
      closable={{ "aria-label": "Close Button", placement: "end" }}
      onClose={onClose}
      open={isOpen}
      placement="right"
      size={500}
      destroyOnHidden={false}
      maskClosable={!disableBackdropClose}
      styles={{
        mask: {
          background: "rgba(0,0,0,0.2)",
          backdropFilter: "blur(2px)",
          transition: "all 0.3s ease",
        },
        body: {
          transition: "all 0.3s ease",
        },
      }}
    >
      {children}
    </Drawer>
  );
};

export default Modal;